const styles = {
  imageList: {
    'max-width': '370px'
  }
};

export default styles;
